import { useMountEffect } from '@client/hooks/utils.hooks';
import { persistor, getStore, backupReducer } from '@client/store';
import { Main } from './ErrorBoundary/Main';

export const ErrorBoundary = () => {
  useMountEffect(() => {
    if (caches) {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      });
    }

    persistor.pause();
    persistor.purge().then(() => {
      const store = getStore();

      persistor.replaceReducer(backupReducer);
      store.replaceReducer(backupReducer);

      persistor.persist();
    });
  });

  return <Main />;
};
